export function titleDepositDay(title) {
  const raw = title?.titleDepositedAt || title?.renewedAt || title?.uploadedAt || title?.createdAt;
  if (!raw || Number.isNaN(Date.parse(raw))) return '';
  return new Intl.DateTimeFormat('sv-SE', {timeZone:'Europe/Paris'}).format(new Date(raw));
}
export function validatePrefectureControlDate(title, checkedAt) {
  const deposit = titleDepositDay(title);
  if (deposit && checkedAt < deposit) return 'Le contrôle doit être effectué après le dépôt du titre actuel. Un contrôle antérieur ne valide pas ce titre.';
  return '';
}
